const topics = [
  {
    title: "Multiplication Facts",
    slug: "multiplicationfacts",
    standardNumber: "NC.3.OA.7",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Division Facts",
    slug: "divisionfacts",
    standardNumber: "NC.3.OA.7",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Word Problems",
    slug: "wordproblems",
    standardNumber: "NC.3.OA.8",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Multiplication Patterns",
    slug: "multiplicationpatterns",
    standardNumber: "NC.3.OA.9",
    description: "Operations and Algebraic Thinking",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Adding & Subtracting",
    slug: "addingandsubtracting",
    standardNumber: "NC.3.NBT.2",
    description: "Number and Operations in Base Ten",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Fraction Definitions",
    slug: "fractiondefinitions",
    standardNumber: "NC.3.NF.1",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Equivalent Fractions",
    slug: "equivalentfractions",
    standardNumber: "NC.3.NF.3",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Compare Fractions",
    slug: "comparefractions",
    standardNumber: "NC.3.NF.4",
    description: "Number and Operations – Fractions",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Telling Time",
    slug: "tellingtime",
    standardNumber: "NC.3.MD.1",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "US Customary",
    slug: "uscustomary",
    standardNumber: "NC.3.MD.2",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Pictograph",
    slug: "pictograph",
    standardNumber: "NC.3.MD.3",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Bar Graph",
    slug: "bargraph",
    standardNumber: "NC.3.MD.3",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Area",
    slug: "area",
    standardNumber: "NC.3.MD.5",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Perimeter",
    slug: "perimeter",
    standardNumber: "NC.3.MD.8",
    description: "Measurement and Data",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Shapes",
    slug: "shapes",
    standardNumber: "NC.3.G.1",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  },
  {
    title: "Quadrilaterals",
    slug: "quadrilaterals",
    standardNumber: "NC.3.G.1",
    description: "Geometry",
    gameType: "multipleChoice",
    titleImage: "",
    video: "",
    music: "",
    lyrics: []
  }
];
export default topics;